import React, { useState, useCallback, useMemo } from 'react';
import { AdUnit } from '@yuuues/myadserver-sdk-react';
import { useAds } from '../context';
import './Advertisement.css';

/**
 * Advertisement component using @yuuues/myadserver-sdk-react
 *
 * Available zones:
 * - footer-banner: Bottom of the app (728x90 leaderboard)
 * - game-screen: During gameplay (300x250)
 * - results-screen: After completing a round (300x250)
 * - sidebar: Sidebar placement (300x600)
 */
const Advertisement = ({ zone = 'footer-banner', className = '' }) => {
  const { adsEnabled, loading } = useAds();
  const [hasAd, setHasAd] = useState(true);

  const handleLoad = useCallback(() => {
    // Ad loaded successfully
  }, []);

  const handleEmpty = useCallback(() => {
    setHasAd(false);
  }, []);

  const handleError = useCallback(() => {
    setHasAd(false);
  }, []);

  // Memoize options to prevent unnecessary re-renders
  const adOptions = useMemo(() => ({
    onSuccess: handleLoad,
    onEmpty: handleEmpty,
    onError: handleError
  }), [handleLoad, handleEmpty, handleError]);

  // Don't render if ads are disabled, loading, or no ad available
  if (!adsEnabled || loading || !hasAd) {
    return null;
  }

  return (
    <div className={`advertisement-container ad-${zone} ${className}`}>
      <AdUnit
        zone={zone}
        className="ad-unit"
        fallback={null}
        skeleton={null}
        lazy={false}
        impressionThreshold={0.5}
        options={adOptions}
      />
    </div>
  );
};

export default Advertisement;
